import classNames from 'classnames';
import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Link } from 'react-router-dom';
import { Container, Heading, useIsMobile } from 'yoso';
import { HeaderSticky } from '~/components/Header';
import { T, t } from '~/components/I18n';
import { NoticeListErrorFallback } from '~/components/Notice/Error/NoticeListErrorFallback';
import { NoticeList } from '~/components/Notice/List';
import { Page } from '~/components/Page';
import { setTimestampForNotice } from '~/components/Support/Support.helpers';
import { TabNav } from '../Nav/Tab';
import { useNoticeParams } from './Notice.hooks';
import styles from './NoticePage.module.scss';

export const NoticePage = () => {
  const isMobile = useIsMobile();
  useEffect(() => {
    setTimestampForNotice();
  }, []);
  const { category } = useNoticeParams();
  return (
    <Page className={styles.root} data-event-page_name="Notice_List">
      <Container margin="auto">
        <div className={styles.header}>
          <Heading level={1} className={styles.title}>
            <T name="citizen_notice" />
          </Heading>
        </div>
        <div>
          <HeaderSticky
            rootMargin={`${isMobile ? '-97px' : '-118px'} 0px 0px 0px`}
            className={styles.headerSticky}>
            <TabNav className={styles.tab}>
              <li>
                <Link
                  to={{ search: '?category=all', state: { scroll: 'restore' } }}
                  className={classNames({ active: category === 'all' })}
                  replace>
                  {t('citizen_notice_category_all')}
                </Link>
              </li>
              <li>
                <Link
                  to={{ search: '?category=notice', state: { scroll: 'restore' } }}
                  className={classNames({ active: category === 'notice' })}
                  replace>
                  {t('citizen_notice_category_notice')}
                </Link>
              </li>
              <li>
                <Link
                  to={{ search: '?category=event', state: { scroll: 'restore' } }}
                  className={classNames({ active: category === 'event' })}
                  replace>
                  {t('citizen_notice_category_event')}
                </Link>
              </li>
              <li>
                <Link
                  to={{ search: '?category=winners', state: { scroll: 'restore' } }}
                  className={classNames({ active: category === 'winners' })}
                  replace>
                  {t('citizen_notice_category_winners')}
                </Link>
              </li>
            </TabNav>
          </HeaderSticky>
          <ErrorBoundary
            resetKeys={[category]}
            fallbackRender={(props) => <NoticeListErrorFallback {...props} />}>
            <NoticeList category={category} />
          </ErrorBoundary>
        </div>
      </Container>
    </Page>
  );
};
